// import Vue from 'vue';
import {
  Dialog,
  Toast
} from 'vant';
import {
  waitPurchase
} from '@/api/api';
import {
  isYoJiangApp,
  isWechat,
  isMobile,
  urlParam,
  addParam,
  deleteParam
} from '@/common/js/utils';
import {
  MONEY_TYPE_ALIPAY,
  MONEY_TYPE_HUABEI,
  MONEY_TYPE_UNIONPAY_INSTALLMENT,
  MONEY_TYPE_UNIONPAY_FQ
} from '@/common/js/config'; // , MONEY_TYPE_WECHAT
import request from '@/plugins/axios';

let waitPaidTimer = null;
let keepWaitPaid = false;
let waitPaidRetryCount = 0;
let globalOptions = null;
const paidSuccessUrlKey = 'paid_success';
const paidFailUrlKey = 'paid_fail';
const urlPaidSuccess = urlParam(paidSuccessUrlKey);
const urlPaidFail = urlParam(paidFailUrlKey);
let urlPurchaseId = urlParam('purchase_id') || urlParam('wait_purchase');

/**
 * @description 校验支付宝支付
 * @param {*} purchaseId
 */
const checkPayWst = (purchaseId) => {
  Dialog.confirm({
    title: '等待您完成支付...',
    message: '请在支付页面继续完成支付，并根据情况点击下方按钮',
    confirmButtonText: '已完成支付',
    confirmButtonColor: '#F5A758',
    cancelButtonText: '重新支付',
    cancelButtonColor: '#999',
    closeOnPopstate: false
  })
    .then(() => {
      // on confirm
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '订单确认中'
      });

      waitPurchase(purchaseId)
        .then((res) => {
          Toast.clear();

          try {
            if (res.finished) {
              // console.log('[支付完成]');
              Toast.success('支付成功');
              if (
                window.windowOnPaidSuccess
                && typeof window.windowOnPaidSuccess === 'function'
              ) {
                window.windowOnPaidSuccess();
              } else {
                window.location.reload();
              }
            } else {
              Toast('支付失败');
            }
          } catch (err) {
            console.error(err);
            window.location.reload();
          }
        })
        .catch((err) => {
          console.error(err);
          // window.location.reload() 还会带参数purchase_id
          // hrefUrl不带参数purchase_id
          // window.location.href = hrefUrl;
        });
    })
    .catch(() => {});
};

const payment = {
  methods: {
    aliH5Pay(options) {
      // console.log('[支付宝-H5支付]');
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });

      const tradeType = 'mweb';

      request.get(options.api_url, {
        params: {
          trade_type: tradeType
        }
      })
        .then((result) => {
          const res = result.data;

          Toast.clear();
          options.onReady();

          if (result.message) {
            Toast(result.message);
            return;
          }

          // error_msg: 商户号该产品权限预开通中，请等待产品开通后重试
          if (res.error_msg) {
            // console.log(res.error_msg);
            Toast(res.error_msg);
            return;
          }

          if (res.money === 0) {
            options.onPaid();
            return;
          }

          const purchaseId = res.purchase_id;
          checkPayWst(purchaseId);

          if (isWechat()) {
            let hrefUrl = window.location.href;
            hrefUrl = addParam(hrefUrl, 'wait_purchase', purchaseId);
            window.history.replaceState(null, null, hrefUrl);
            // console.log(location.href);
            setTimeout(() => {
              window.location.href = `/lesson/alipay_jump?pid=${purchaseId}&page_id=${Math.random()
                .toString(36)
                .slice(-8)}`;
            }, 200);
          } else {
            // hrefUrl = addParam(hrefUrl, 'purchase_id', res.purchase_id)
            // window.history.replaceState(null, null, hrefUrl)
            window.location.href = res.mweb_url;
          }
        })
        .catch((err) => {
          console.error(err);
          Toast(err.message);
          options.onReady();
        });
    },
    // 检测是否支付
    checkPaidCompletion(purchaseId) {
      if (waitPaidTimer) {
        clearTimeout(waitPaidTimer);
      }
      // waitPaidTimer && clearTimeout(waitPaidTimer);
      waitPurchase(purchaseId).then((res) => {
        Toast.clear();
        try {
          if (res.finished) {
            // console.log('[支付完成]');
            if (
              window.windowOnPaidSuccess
              && typeof window.windowOnPaidSuccess === 'function'
            ) {
              window.windowOnPaidSuccess();
            } else {
              globalOptions.onPaid();
            }
          } else {
            // console.log('[支付未完成]');
            // eslint-disable-next-line no-lonely-if
            if (window.windowOnPaidFail && typeof window.windowOnPaidFail === 'function') {
              window.windowOnPaidFail();
            } else {
              globalOptions.onReturnComplete();
            }
          }
        } catch (err) {
          console.error(err);
        }
      });
    },
    wechatH5Pay(options) {
      // console.log('[微信-H5支付]');
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });

      const tradeType = 'mweb';

      request.get(options.api_url, {
        params: {
          trade_type: tradeType
        }
      })
        .then((result) => {
          const res = result.data;
          // console.log('[微信-H5支付]-res: ', res);
          // console.log('hide loading');
          Toast.clear();
          options.onReady(true);

          if (result.message) {
            Toast(result.message);
            return;
          }

          if (res.money === 0) {
            options.onPaid();
            return;
          }
          // const purchaseId = res.purchase_id
          if (!res.mweb_url) {
            this.wxScanPay(options);
            return;
          }
          // return console.log(res.mweb_url)
          let locationHref = window.location.href;
          locationHref = addParam(locationHref, 'purchase_id', res.purchase_id);
          if (
            options.windowOnPaidSuccess
            && typeof window.windowOnPaidSuccess === 'function'
          ) {
            locationHref = addParam(locationHref, paidSuccessUrlKey, 1);
          }

          if (
            options.windowOnPaidFail
            && typeof window.windowOnPaidFail === 'function'
          ) {
            locationHref = addParam(locationHref, paidFailUrlKey, 1);
          }

          window.history.replaceState(null, null, locationHref);
          const mwebUrl = `${res.mweb_url}&redirect_url=${encodeURIComponent(
            locationHref
          )}`;
          // console.log('mwebUrl', mwebUrl);
          window.location.href = mwebUrl;
        })
        .catch((err) => {
          console.error(err);
          Toast.clear();
          Toast(err.message);
          options.onReady(false);
        });
    },
    unionpayInstallmentH5Pay(options) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });

      request.get(options.api_url, { params: { trade_type: 'mweb' } }).then((result) => {
        const res = result.data;
        Toast.clear();
        options.onReady(true);

        if (result.message) {
          Toast(result.message);
          return;
        }

        if (res.money === 0) {
          options.onPaid();
          return;
        }

        if (!res.mweb_url) {
          this.wxScanPay(options);
          return;
        }

        // 将支付源页面缓存，支付完成后由回跳结果页获取并重新返回
        let locationHref = window.location.href;
        locationHref = addParam(locationHref, 'purchase_id', res.purchase_id);
        if (options.windowOnPaidSuccess && typeof window.windowOnPaidSuccess === 'function') {
          locationHref = addParam(locationHref, paidSuccessUrlKey, 1);
        }
        if (options.windowOnPaidFail && typeof window.windowOnPaidFail === 'function') {
          locationHref = addParam(locationHref, paidFailUrlKey, 1);
        }
        window.history.replaceState(null, null, locationHref);
        window.sessionStorage.setItem('unionPayInstallmentReturnUrl', locationHref);

        // 打开银联支付H5页面
        window.location.href = res.mweb_url;
      }).catch((err) => {
        console.error(err);
        Toast.clear();
        Toast(err.message);
        options.onReady(false);
      });
    },
    unionpayFQH5Pay(options) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });

      request.get(options.api_url, { params: { trade_type: 'mweb' } }).then((result) => {
        const res = result.data;
        Toast.clear();
        options.onReady(true);

        if (result.message) {
          Toast(result.message);
          return;
        }

        if (res.money === 0) {
          options.onPaid();
          return;
        }

        if (!res.mweb_url) {
          this.wxScanPay(options);
          return;
        }

        // 将支付源页面缓存，支付完成后由回跳结果页获取并重新返回
        let locationHref = window.location.href;
        locationHref = addParam(locationHref, 'purchase_id', res.purchase_id);
        if (options.windowOnPaidSuccess && typeof window.windowOnPaidSuccess === 'function') {
          locationHref = addParam(locationHref, paidSuccessUrlKey, 1);
        }
        if (options.windowOnPaidFail && typeof window.windowOnPaidFail === 'function') {
          locationHref = addParam(locationHref, paidFailUrlKey, 1);
        }
        window.history.replaceState(null, null, locationHref);
        window.sessionStorage.setItem('unionPayFQReturnUrl', locationHref);

        // 打开银联支付H5页面
        window.location.href = res.mweb_url;
      }).catch((err) => {
        console.error(err);
        Toast.clear();
        Toast(err.message);
        options.onReady(false);
      });
    },
    wxJsPay(options) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });

      const tradeType = 'jsapi';

      request.get(options.api_url, {
        params: {
          trade_type: tradeType
        }
      })
        .then((result) => {
          // console.log(result.data);
          const res = result.data;
          // console.log('[微信Js支付]-res: ', res);
          // console.log('hide loading');
          Toast.clear();

          if (result.message) {
            Toast(result.message);
            return;
          }

          if (res.pay_money === 0) {
            options.onPaid();
            return;
          }

          options.onReady();
          // const purchaseId = res.purchase_id
          if (!res.package) {
            // console.log('[微信JS支付] - no package');
            // options.clear_purchase_id = purchaseId
            this.wxScanPay(options);
            return;
          }

          const purchaseId = res.purchase_id;
          // eslint-disable-next-line no-unused-vars
          const payData = {
            timestamp: res
              .timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: res.nonceStr, // 支付签名随机串，不长于 32 位
            package: res.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
            signType: res.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: res.sign, // 支付签名
            success: () => {
              // console.log('[微信JS支付] - success');
              this.waitPaid(options, purchaseId);
            },
            fail: () => {
              // console.log('[微信JS支付] - fail');
              this.wxScanPay(options);
            },
            cancel: () => {
              // 支付取消
              // console.log('支付取消');
            }
          };

          // 万松涛：调用微信支付
          // eslint-disable-next-line no-undef
          wx.chooseWXPay(payData);
        })
        .catch(() => {
          Toast.clear();
          options.onReady();
        });
    },
    wxScanPay(options) {
      // console.log('[微信扫码支付]');
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      });
      const tradeType = 'native';

      request.get(options.api_url, {
        params: {
          trade_type: tradeType
        }
      })
        .then((result) => {
          const res = result.data;
          // console.log('[微信扫码支付]-res: ', res);
          // console.log('hide loading')
          Toast.clear();
          // const purchaseId = res.purchase_id

          if (result.message) {
            Toast(result.message);
            return;
          }

          if (res.pay_money === 0) {
            options.onPaid();
            return;
          }
          options.onReady();
          // App.hideLoading();
          // console.log('hide loading');
          if (options.onScanPay) {
            let qrcodeImage = '';
            if (res.qrcode) {
              qrcodeImage = `data:image/png;base64,${res.qrcode}`;
            } else {
              qrcodeImage = res.jump_url;
            }
            options.onScanPay(qrcodeImage, res.money);
          }
          this.waitPaid(options, res.purchase_id);
        })
        .catch(() => {
          Toast.clear();
          options.onReady();
        });
    },
    waitPaid(options, purchaseId) {
      // eslint-disable-next-line no-unused-expressions
      waitPaidTimer && clearTimeout(waitPaidTimer);

      waitPurchase(purchaseId)
        .then((res) => {
          // console.log('wait-paid res', res);
          waitPaidRetryCount = 0;
          if (res.finished) {
            this.stopWaitPaid();
            globalOptions.onPaid();
          } else {
            // eslint-disable-next-line no-unused-expressions
            waitPaidTimer && clearTimeout(waitPaidTimer);
            if (keepWaitPaid) {
              waitPaidTimer = setTimeout(() => {
                this.waitPaid(options, purchaseId);
              }, 200);
            }
          }
        })
        .then(() => {
          // eslint-disable-next-line no-plusplus
          waitPaidRetryCount++;
          if (waitPaidRetryCount > 3) {
            waitPaidRetryCount = 0;
            // eslint-disable-next-line no-unused-expressions
            waitPaidTimer && clearTimeout(waitPaidTimer);
          } else if (keepWaitPaid) {
            waitPaidTimer = setTimeout(() => {
              this.waitPaid(options, purchaseId);
            }, 200);
          }
        });
    },
    stopWaitPaid() {
      keepWaitPaid = false;
      // eslint-disable-next-line no-unused-expressions
      waitPaidTimer && clearTimeout(waitPaidTimer);
    },
    // eslint-disable-next-line consistent-return
    buy(options) {
      // console.log('更新到了');
      keepWaitPaid = true;
      globalOptions = options;
      let locationHref = window.location.href;

      // 清除location.href带有的purchase_id、wait_purchase参数
      if (urlParam('purchase_id')) {
        locationHref = deleteParam(locationHref, 'purchase_id');
      }

      if (urlParam('wait_purchase')) {
        locationHref = deleteParam(locationHref, 'wait_purchase');
      }

      window.history.replaceState(null, null, locationHref);
      // console.log('buy函数里面的', locationHref);

      if (isYoJiangApp()) {
        // 有讲课堂App里，使用自定义的接口支付
        // this.appH5Pay(options)
        if (options.money_type === MONEY_TYPE_ALIPAY || options.money_type
          === MONEY_TYPE_HUABEI) {
          // console.log('手机端吊起支付（非微信）-- 支付宝支付');
          this.aliH5Pay(options);
        } else {
          // console.log('手机端吊起支付（非微信）-- wechatH5Pay');
          this.wechatH5Pay(options);
        }
      } else if (options.money_type === MONEY_TYPE_UNIONPAY_INSTALLMENT) {
        // 银联分期支付-跳转第三方H5页面
        this.unionpayInstallmentH5Pay(options);
      } else if (options.money_type === MONEY_TYPE_UNIONPAY_FQ) {
        // 银联分期免息支付-跳转第三方H5页面
        this.unionpayFQH5Pay(options);
      } else if (isWechat() && isMobile()) {
        // console.log('手机微信端吊起支付');
        // 手机微信端吊起支付
        if (options.money_type === MONEY_TYPE_ALIPAY || options.money_type
          === MONEY_TYPE_HUABEI) {
          return this.aliH5Pay(options);
        }

        this.wxJsPay(options);
      } else if (isMobile()) {
        // console.log('手机端吊起支付（非微信）');
        // 手机端吊起支付（非微信）
        if (urlPurchaseId) {
          // eslint-disable-next-line consistent-return
          return;
        }

        if (options.money_type === MONEY_TYPE_ALIPAY || options.money_type
          === MONEY_TYPE_HUABEI) {
          // console.log('手机端吊起支付（非微信）-- 支付宝支付');
          this.aliH5Pay(options);
        } else {
          // console.log('手机端吊起支付（非微信）-- wechatH5Pay');
          this.wechatH5Pay(options);
        }
      } else {
        // console.log('默认');
        // 默认使用扫码支付
        this.wxScanPay(options);
      }
    },
    onCheckPurchaseId() {
      checkPurchaseId();
    }
  }
};

// 如果返回链接 含有 purchase_id ，就进行检测
function checkPurchaseId() {
  urlPurchaseId = urlParam('purchase_id') || urlParam('wait_purchase');
  if (!urlPurchaseId) {
    return;
  }
  let hrefUrl = deleteParam(window.location.href, 'purchase_id');
  // console.log('urlPurchaseId', urlPurchaseId);
  // console.log('hrefUrl', hrefUrl);
  if (urlPaidSuccess) {
    hrefUrl = deleteParam(hrefUrl, paidSuccessUrlKey);
  }
  if (urlPaidFail) {
    hrefUrl = deleteParam(hrefUrl, paidFailUrlKey);
  }
  // hrefUrl = App.utils.addParam(hrefUrl, 'reload', 1);
  window.history.replaceState(null, null, hrefUrl);
  // console.log('应该不带pid了，', window.location.href);
  // console.log(location.href);

  // eslint-disable-next-line no-unused-expressions
  waitPaidTimer && clearTimeout(waitPaidTimer);

  Dialog.confirm({
    title: '等待您完成支付...',
    message: '请在支付页面继续完成支付，并根据情况点击下方按钮',
    confirmButtonText: '已完成支付',
    confirmButtonColor: '#F5A758',
    cancelButtonText: '重新支付',
    cancelButtonColor: '#999'
  })
    .then(() => {
      // on confirm
      // console.log('点击了我已支付');
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '订单确认中'
      });

      waitPurchase(urlPurchaseId)
        .then((res) => {
          Toast.clear();
          urlPurchaseId = null;

          if (urlParam('purchase_id')) {
            hrefUrl = deleteParam(hrefUrl, 'purchase_id');
          }

          if (urlParam('wait_purchase')) {
            hrefUrl = deleteParam(hrefUrl, 'wait_purchase');
          }
          window.history.replaceState(null, null, hrefUrl);

          try {
            if (res.finished) {
              // console.log('[支付完成]');
              Toast.success('支付成功');
              if (
                window.windowOnPaidSuccess
                && typeof window.windowOnPaidSuccess === 'function'
              ) {
                window.windowOnPaidSuccess();
              } else {
                // window.location.reload()
                window.location.href = hrefUrl;
              }
            } else {
              // console.log('[支付未完成]');
              // eslint-disable-next-line no-lonely-if
              if (
                window.windowOnPaidFail
                && typeof window.windowOnPaidFail === 'function'
              ) {
                window.windowOnPaidFail();
              } else {
                // window.location.reload()
                window.location.href = hrefUrl;
              }
            }
          } catch (err) {
            console.error(err);
            // window.location.reload()
            window.location.href = hrefUrl;
          }
        })
        .catch((err) => {
          console.error(err);
          // window.location.reload() 还会带参数purchase_id
          // hrefUrl不带参数purchase_id
          window.location.href = hrefUrl;
        });
    })
    .catch(() => {
      // on cancel
      // console.log('点击了重新支付');
      urlPurchaseId = null;
      if (urlParam('purchase_id')) {
        hrefUrl = deleteParam(hrefUrl, 'purchase_id');
      }
      if (urlParam('wait_purchase')) {
        hrefUrl = deleteParam(hrefUrl, 'wait_purchase');
      }
      window.history.replaceState(null, null, hrefUrl);
      if (
        window.windowOnPaidFail
        && typeof window.windowOnPaidFail === 'function'
      ) {
        window.windowOnPaidFail();
      }
    });
}

// 相关H5支付完成之后，
checkPurchaseId();

export default payment;
